import * as Yup from 'yup';

const countrySchema = Yup.object().shape({
  labelEn: Yup.string().required('English Label is required.'),
  labelAr: Yup.string().required('Arabic Label is required.'),
  emoji: Yup.string().required('Emoji is required.'),
  code: Yup.string().required('Code is required.'),
});

export default countrySchema;